import { childIssuesInitialDisplayCount as CHILD_ISSUES_INITIAL_DISPLAY_COUNT } from '@jira/issue__constants/src/childIssuesInitialDisplayCount.tsx';
import { getForgeSpecificVariables } from '@jira/issue__main-issue-agg-query/src/getMainIssueViewAggQueryVariables.tsx';
import { JiraSiteAri } from '@atlassian/ari/jira/site';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import type { WorkItemLazyQueryWrapperEntryPointParams } from './WorkItemLazyQueryWrapper.entrypoint.types.tsx';
import type { WorkItemLazyQueryWrapperEntrypointContentQuery$variables } from './__generated__/WorkItemLazyQueryWrapperEntrypointContentQuery.graphql';
import type { WorkItemLazyQueryWrapperQuery$variables } from './__generated__/WorkItemLazyQueryWrapperQuery.graphql';

const FORGE_MODULES = getForgeSpecificVariables();

const getChildIssuesFieldIdsQueryVariables = (): string[] => {
	const childIssuesFieldIds = ['issuetype'];

	if (!fg('relay-migration-edit-worklog') && !fg('jpx-93-unship-legacy-timetracking')) {
		childIssuesFieldIds.push('timetracking');
	}

	if (!fg('jira-issue-view-child-issues-panel-realtime-update')) {
		childIssuesFieldIds.push('status');
	}

	return childIssuesFieldIds;
};

const getIssueSearchForChildIssueQueryVariables = (issueKey: string | null) => ({
	issueSearchInput: fg('jira-issue-view-child-work-items-ssr-fg')
		? { jql: issueKey ? `parent = ${issueKey}` : '' }
		: { childIssuesInput: { parentIssueKey: issueKey || '' } },
	fieldSetsInput: {
		viewInput: { namespace: 'CHILD_ISSUE_PANEL', context: { issueContext: { issueKey } } },
	},
	childIssuesFieldIds: getChildIssuesFieldIdsQueryVariables(),
	childIssuesAmountOfColumns: 500,
	childIssuesFirst: fg('jira_child_work_items_pagination')
		? CHILD_ISSUES_INITIAL_DISPLAY_COUNT
		: undefined,
	childWorkItemsSSRUIEnabled: Boolean(fg('jira-issue-view-child-work-items-ssr-fg')),
	sideBarLayoutDecompositionEnabled: Boolean(fg('side-layout-work-item-integration')),
	shouldUseNewChildWorkItemsDatafetcher: true,
	isInitialLoadQuery: true,
});

type WorkItemLazyQueryWrapperQueryVariables = WorkItemLazyQueryWrapperQuery$variables &
	WorkItemLazyQueryWrapperEntrypointContentQuery$variables;

export const getWorkItemLazyQueryWrapperQueryVariables = ({
	issueKey,
	cloudId,
	isAnonymous,
}: WorkItemLazyQueryWrapperEntryPointParams): WorkItemLazyQueryWrapperQueryVariables => ({
	issueKey,
	projectKey: issueKey.split('-')[0],
	cloudId,
	siteAri: cloudId ? JiraSiteAri.create({ siteId: cloudId }).toString() : '',
	consistentRead: Boolean(fg('design-panel-ags-consistent-read')),
	includeDesignPanelData: Boolean(!isAnonymous),
	includeFigmaConfigData: fg('remove_ctiaq_config_state') ? Boolean(!isAnonymous) : false,
	...FORGE_MODULES,
	applicationKey: 'JIRA_SOFTWARE',
	issueViewAddAttachmentFlag: false,
	includeAgenticWorkItemData: Boolean(expVal('work_item_for_quadratic', 'isEnabled', false)),
	isWorkItemPlatformisationPhase1Enabled: Boolean(
		expVal('work_item_v2_platformisation_phase1', 'isEnabled', false),
	),
	...getIssueSearchForChildIssueQueryVariables(issueKey),
});
